import * as Sentry from "@sentry/react";
import { initTracer } from "./tracer";

// Initialize OpenTelemetry browser distributed tracing to Tempo
initTracer("crmline-frontend");

const dsn = (typeof window !== "undefined" && window.__RUNTIME_CONFIG__?.SENTRY_DSN)
  || process.env.REACT_APP_SENTRY_DSN
  || (typeof import.meta !== "undefined" && import.meta.env?.VITE_SENTRY_DSN);

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV || "production",
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/.*\.linesystem\.uz/,
      /^https:\/\/.*\.erpline\.uz/,
      /^https:\/\/.*\.crmline\.uz/,
      /^https:\/\/.*\.hrline\.uz/,
    ],
    propagateTraceparent: false,
    tracesSampleRate: 1.0,
  });
}

export default Sentry;
